/* eslint-disable no-plusplus */
import React, { useMemo, useState } from 'react';
import { TubeChartGrid } from '../../VesselInformation/components/TubeChart/Diagram/tubeChartGrid';
import { TubeChartLayoutProps } from '../types';
import { Circle } from '../../VesselInformation/utils/tubeChartTypes';

function TubeChartLayout({ poly, head }: TubeChartLayoutProps) {
  const [oddRemovedTopRows, setOddRemovedTopRows] = useState(false);
  const filteredCircles = useMemo(() => {
    // remove top empty rows
    const firstVisibleIndex = poly?.circles?.findIndex((group: Circle[]) => group?.some((item: Circle) => item?.visible));
    let lastVisibleIndex = -1;
    // remove bottom empty rows
    for (let i = poly.circles.length - 1; i >= 0; i--) {
      if (poly?.circles?.[i].some((item) => item?.visible)) {
        lastVisibleIndex = i;
        break;
      }
    }
    const filtered = firstVisibleIndex === -1 ? [] : poly?.circles?.slice(firstVisibleIndex, lastVisibleIndex + 1);
    setOddRemovedTopRows(firstVisibleIndex % 2 !== 0);

    // remove tubes column
    if (!filtered?.length) return filtered;

    const colCount = filtered?.[0]?.length;
    let firstVisibleCol = 0;

    // remove left empty columns
    for (let col = 0; col < colCount; col++) {
      const anyVisible = filtered?.some((row) => row?.[col]?.visible);
      if (anyVisible) {
        firstVisibleCol = col;
        break;
      }
    }
    // remove last empty columns
    let lastVisibleCol = colCount - 1;
    for (let col = colCount - 1; col >= 0; col--) {
      const anyVisible = filtered?.some((row) => row?.[col]?.visible);
      if (anyVisible) {
        lastVisibleCol = col;
        break;
      }
    }

    return filtered?.map((row) => row.slice(firstVisibleCol, lastVisibleCol + 1));
  }, [poly]);

  const polyData = useMemo(() => ({
    ...poly, circles: filteredCircles, rows: filteredCircles?.length, columns: filteredCircles?.[0]?.length,
  }), [filteredCircles]);

  return (
    <div className="p10 noScrollWidth noTableBreak w100 textCenter" style={{ position: 'relative' }}>
      {poly?.totalVisible > 0 && (
        <TubeChartGrid
          polygon={polyData}
          polyCircles={[[...polyData.circles]]}
          index={0}
          setPolyCircles={() => {}}
          isPdfReport
          isRowsRemoved={oddRemovedTopRows}
        />
      )}
      {head && <div className="tubeBundleHeader" style={{ position: 'absolute', top: 0, right: '28%' }}>{head}</div>}
    </div>
  );
}

export default TubeChartLayout;
